module.exports = __webpack_public_path__ + "img/canbadge_egg_w46mm.e1714652.png";